export default class FileRequest{
	constructor(pax={}, hotelBookingRequest = {}, serviceBookingsRequest = [], type = ""){
		this.autoConfirm = false;
		this.pax = pax;
		this.hotelBooking = hotelBookingRequest;
		this.serviceBookings = serviceBookingsRequest;
		this.type = type;
		this.origin = "EVENTS_SITE";
	}

}



// WEBPACK FOOTER //
// ./src/model/FileRequest.js